import { FC } from 'react';
import { EasyField } from 'react-bootstrap-formutil';
import { NameTypeEnum } from 'types/customer';
import FirstName from '../components/FirstName';
import LastName from '../components/LastName';
import MiddleInitial from '../components/MiddleInitial';
import { BaseRealNameInfoProps } from '../type';

const Common: FC<BaseRealNameInfoProps> = ({ disabled }) => {
    return (
        <div>
            <FirstName disabled={disabled} />
            <MiddleInitial disabled={disabled} />
            <LastName disabled={disabled} />
            <EasyField name="name_type" $defaultValue={NameTypeEnum.COMMON} type="hidden" />
        </div>
    );
};

export default Common;
